<ng-container *ngIf="isModal; else elseTemplate">
  <ng-container
    *ngIf="
      lastDataDeviceMapped$ | async;
      let lastDataDeviceMapped;
      else: showSpinner
    "
  >
    <mat-card class="UltimasMedicionesCard">
      <mat-card-header class="card-header card-header-datatype">
        <mat-card-title
          >{{ lastDataDeviceMapped.nombreDispositivo }}
        </mat-card-title>
        <mat-card-subtitle>{{
          "ULTIMAS_MEDICIONES.SHORT_TITLE" | translate
        }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="card-content-datatype">
        <table
          *ngIf="lastDataDeviceMapped.medicionesTable.length > 0"
          mat-table
          [dataSource]="lastDataDeviceMapped.medicionesTable"
          class="mat-elevation-z8"
        >
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"></td>
          </ng-container>
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef class="w-device">Nombre</th>
            <td mat-cell *matCellDef="let element" class="w-device">
              {{ element.nombre }}
            </td>
          </ng-container>
          <ng-container matColumnDef="lastFecha">
            <th mat-header-cell *matHeaderCellDef class="w-last-fecha">
              Fecha
            </th>
            <td mat-cell *matCellDef="let element" class="w-last-fecha">
              <ng-container *ngIf="element.lastFecha; else elseTemplate">
                <span> {{ element.lastFecha }} </span>
              </ng-container>
              <ng-template #elseTemplate> </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="stats_last">
            <th mat-header-cell *matHeaderCellDef class="w-medicion">
              Ultima Medicion
            </th>
            <td mat-cell *matCellDef="let element" class="w-medicion">
              {{ element.stats_last | number: "1.0-2" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="unidad">
            <th mat-header-cell *matHeaderCellDef>Unidad</th>
            <td mat-cell *matCellDef="let element">{{ element.unidad }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <p *ngIf="lastDataDeviceMapped.mediciones.length == 0">
          No hay datos para mostrar
        </p>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-template #showSpinner>
    <app-loading [loadingText]="loadingText"></app-loading>
  </ng-template>
</ng-container>
<ng-template #elseTemplate>
  <ng-container *ngIf="lastDataDeviceMapped !== null; else showSpinner">
    <mat-card class="UltimasMedicionesCard">
      <mat-card-header class="card-header card-header-datatype">
        <mat-card-title
          >{{ lastDataDeviceMapped.nombreDispositivo }}
        </mat-card-title>
        <mat-card-subtitle>{{
          "ULTIMAS_MEDICIONES.SHORT_TITLE" | translate
        }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="card-content-datatype">
        <table
          *ngIf="lastDataDeviceMapped.medicionesTable.length > 0"
          mat-table
          [dataSource]="lastDataDeviceMapped.medicionesTable"
          class="mat-elevation-z8"
        >
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"></td>
          </ng-container>
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef class="w-device">Nombre</th>
            <td mat-cell *matCellDef="let element" class="w-device">
              {{ element.nombre }}
            </td>
          </ng-container>
          <ng-container matColumnDef="lastFecha">
            <th mat-header-cell *matHeaderCellDef class="w-last-fecha">
              Fecha
            </th>
            <td mat-cell *matCellDef="let element" class="w-last-fecha">
              <ng-container *ngIf="element.lastFecha; else elseTemplate">
                <span> {{ element.lastFecha }} </span>
              </ng-container>
              <ng-template #elseTemplate> </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="stats_last">
            <th mat-header-cell *matHeaderCellDef class="w-medicion">
              Ultima Medicion
            </th>
            <td mat-cell *matCellDef="let element" class="w-medicion">
              {{ element.stats_last | number: "1.0-2" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="unidad">
            <th mat-header-cell *matHeaderCellDef>Unidad</th>
            <td mat-cell *matCellDef="let element">{{ element.unidad }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <!-- Group header -->
          <!-- <ng-container matColumnDef="groupHeader">
                            <td colspan="999" mat-cell *matCellDef="let groupBy">
                                <span *ngIf="groupBy.codigo!=='null'">
                                    <strong> {{ groupBy.codigo}}</strong>
                                </span>
                                <span *ngIf="groupBy.codigo==='null'">
                                    <strong> Generales </strong>
                                </span>
                            </td>
                        </ng-container>
                        <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup"> </tr> -->
        </table>
        <p *ngIf="lastDataDeviceMapped.mediciones.length == 0">
          No hay datos para mostrar
        </p>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-template #showSpinner>
    <app-loading [loadingText]="loadingText"></app-loading>
  </ng-template>
</ng-template>
